module.exports = __webpack_public_path__ + "img/250460827_2025_4-2.12db97ae.png";